import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Tooltip from 'flarum/common/components/Tooltip';
import extractText from 'flarum/common/utils/extractText';
import IndexPage from 'flarum/forum/components/IndexPage';
import pageHero from './pageHero';

// What fof/bookmarks' BookmarkButton has (it adds bookmarked() to the models).

/**
 * fof/bookmarks:
 * - its page borrows the index hero ("Welcome to BimmerDock Community"), so
 *   it gets a page hero like /following;
 * - the post button (in the post header or under the post) is an icon only
 *   (bookmarks.less), so its label moves to a tooltip.
 */
export default function bookmarks() {
  override(IndexPage.prototype, 'hero', function (original) {
    if (app.current.get('routeName') !== 'fof-bookmarks') return original();
    return pageHero(app.translator.trans('fof-bookmarks.forum.page.title'), app.translator.trans('bimmerdock-theme.forum.bookmarks.subtitle'), 'BookmarksHero');
  });

  // In a post's dropdown menu the button keeps its label: no tooltip there.
  override('ext:fof/bookmarks/forum/components/BookmarkButton', 'view', function (original) {
    const {
      subject,
      labels,
      className
    } = this.attrs;
    if (labels !== 'postButton' || !className) return original();
    const label = app.translator.trans(`fof-bookmarks.forum.postButton.${subject.bookmarked() ? 'remove' : 'add'}`);
    return m(Tooltip, {
      text: extractText(label)
    }, original());
  });
}